import React from 'react'
import Typography from '@mui/joy/Typography';

export class StatusBar extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      message: 'Welcome to MetaStory'
    }
    this.lastFired = 0
  }

  componentDidMount(){
    let debounce = 50
    if (this.props.debounce && !isNaN(this.props.debounce)) {
      debounce = this.props.debounce
    }
    if( this.props.setTrigger ){
      // console.log('status trigger set')
      let func = message => {
        // console.log('message request')
        let now = Date.now()
        if (!this.lastFired) this.lastFired = now
        else if (this.lastFired + debounce > now) return Promise.resolve()

        return new Promise((resolve) => {
          console.log(message)
          // console.log('message print')
          this.lastFired = now
          setTimeout(()=>{
            // let elm = document.getElementById('status-bar-message')
            // if (elm) {
            //   if(typeof message === 'string'){
            //     elm.innerHTML = message
            //   }else {
            //     // elm.appendChild({__html: message})
            //     elm.dangerouslySetInnerHTML= {__html: message}

            //   }

            // }
            if(typeof message === 'string'){
              this.setState({message:(
                <div style={{paddingLeft:'5px'}} >{message}</div>
              )}, ()=>resolve())
              
            }else{
              this.setState({message}, ()=>resolve())

            }
            

          }, 10)
          // this.setState({message}, resolve)
        })
      }
      this.props.setTrigger(func.bind(this))
      console.log('setting trigger in status')
      func('Welcome to MetaStory')
    }
  }

  render() {
    return (
      <Typography id="status-bar-message"
        level="title-sm"
        variant="plain"
      >
        {this.state.message}
      </Typography>

    )
  }
}
